export default {"src":"/_next/static/media/caret-icon-black.f2d05cdf.svg","height":10,"width":6};